import classnames from 'classnames'
import { useState } from 'react'

import System from 'system'
import { SimpleButton, Tooltip } from 'ui'

import type { FC } from 'react'

export type NewVersionCheckProps = {
  className?: string
}

const NewVersionCheck: FC<NewVersionCheckProps> = ({ className }) => {
  const [updating, setUpdating] = useState(false)
  const updateServiceWorker = async () => {
    if (!updating) {
      setUpdating(true)
      await System.workbox.registration.unregister()
      window.location.reload()
    }
  }
  return (
    <div className={classnames('pt-2 text-right', className)}>
      {System.workbox.registration ? (
        <Tooltip
          tooltip={
            <SimpleButton
              className="text-sm"
              disabled={updating}
              onClick={updateServiceWorker}
              value={updating ? 'Buscando...' : '¡Actualizar!'}
            />
          }
        >
          <span>{System.version}up</span>
        </Tooltip>
      ) : (
        <span>{System.version}lo</span>
      )}
    </div>
  )
}

export default NewVersionCheck
